<template>
  <div class="consulta-pontos">
    <header class="header">
      <h1 class="titulo">📋 Consulta de Registros de Ponto</h1>
    </header>

    <!-- FILTROS -->
    <section class="filtro-section">
      <div class="filtro-grid">
        <div class="campo">
          <label>Funcionário</label>
          <select v-model="filtros.funcionario_id" class="input">
            <option disabled value="">Selecione</option>
            <option v-for="func in funcionariosLista" :key="func.id" :value="func.id">
              {{ func.nome }}
            </option>
          </select>
        </div>

        <div class="campo">
          <label>Data Início</label>
          <input type="date" v-model="filtros.data_inicio" class="input" />
        </div>

        <div class="campo">
          <label>Data Fim</label>
          <input type="date" v-model="filtros.data_fim" class="input" />
        </div>
      </div>

      <div class="acoes">
        <button class="btn-primario" @click="buscarRegistros">
          <i class="fas fa-search"></i> Buscar
        </button>
        <button class="btn-secundario" @click="exportarPDF">
          <i class="fas fa-file-pdf"></i> Exportar PDF
        </button>
        <button class="btn-secundario" @click="abrirModalExportarLote">
          <i class="fas fa-layer-group"></i> Exportar em Lote
        </button>

      </div>
    </section>

    <!-- LOADING -->
    <div v-if="loading" class="estado carregando">
      <div class="spinner"></div>
      <p>Carregando registros...</p>
    </div>

    <!-- VAZIO -->
    <div v-else-if="Object.keys(registrosAgrupados).length === 0" class="estado vazio">
      <i class="fas fa-clipboard-list"></i>
      <h3>Nenhum registro encontrado</h3>
      <p>Ajuste os filtros e tente novamente.</p>
    </div>

    <!-- REGISTROS -->
    <section v-else class="lista-dias">
      <div v-for="(grupo, data) in registrosAgrupados" :key="data" class="card-dia">
        <div class="cabecalho-dia">
          <h3>{{ formatDateTitle(data) }}</h3>

          <div v-if="grupo.semSaida" class="alerta">
            ⚠ Ausência de saída
            <button class="btn-ajustar" @click="abrirModal(data)">Ajustar</button>
          </div>
        </div>

        <table class="tabela-pontos">
          <thead>
            <tr>
              <th>Data/Hora</th>
              <th>Status</th>
              <th>Selfie</th>
              <th>Mapa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(reg, index) in grupo.registros" :key="index">
              <td>{{ formatDate(reg.registro_timestamp) }}</td>
              <td :class="statusClass(reg.registro_tipo)">
                {{ reg.registro_tipo }}
              </td>
              <td>
                <button
                  v-if="reg.selfie_path"
                  class="btn-selfie"
                  @click="abrirModalSelfie(reg.selfie_path)"
                  title="Ver selfie"
                >
                  <i class="fas fa-camera"></i>
                </button>
              </td>
              <td>
                <button
                  v-if="reg.latitude && reg.longitude"
                  class="btn-mapa"
                  @click="abrirMapaRegistro(reg)"
                  title="Ver no mapa"
                >
                  <i class="fas fa-map-marker-alt"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- MODAL SELFIE -->
    <transition name="fade">
      <div v-if="showSelfieModal" class="modal-overlay" @click.self="fecharModalSelfie">
        <div class="modal">
          <button class="modal-close" @click="fecharModalSelfie">✕</button>
          <img :src="selfieUrl" alt="Selfie" class="selfie-img" />
          <button class="btn-primario w-full" @click="fecharModalSelfie">Fechar</button>
        </div>
      </div>
    </transition>

    <!-- MODAL AJUSTE -->
    <transition name="fade">
      <div v-if="showModal" class="modal-overlay" @click.self="fecharModal">
        <div class="modal">
          <button class="modal-close" @click="fecharModal">✕</button>
          <h3 class="modal-title">Ajustar Saída</h3>
          <p><strong>Data:</strong> {{ formatDateTitle(ajusteData) }}</p>

          <label>Hora:</label>
          <input class="input" type="time" v-model="horaAjuste" />

          <div class="modal-acoes">
            <button class="btn-secundario" @click="fecharModal">Cancelar</button>
            <button class="btn-primario" @click="confirmarAjuste">Confirmar</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- MODAL MAPA -->
    <transition name="fade">
      <div v-if="mostrarModalMapa" class="modal-overlay" @click.self="fecharModalMapa">
        <div class="modal">
          <button class="modal-close" @click="fecharModalMapa">✕</button>
          <h3 class="modal-title">📍 Localização do Registro</h3>
          <p class="modal-subtitle">
            {{ registroSelecionado?.localizacao_atual || 'Registro' }}<br />
            {{ formatDate(registroSelecionado?.registro_timestamp) }}
          </p>
          <div class="mapa-container" ref="mapaContainer"></div>
          <p class="coords" v-if="registroSelecionado">
            Lat: {{ registroSelecionado.latitude }} | Lng: {{ registroSelecionado.longitude }}
          </p>
          <button class="btn-primario w-full" @click="fecharModalMapa">Fechar</button>
        </div>
      </div>
    </transition>

    <!-- MODAL DOWNLOAD LOTE -->
    <transition name="fade">
      <div v-if="exportarLoteModal" class="modal-overlay" @click.self="fecharModalExportarLote">
        <div class="modal modal-mobile">
          <button class="modal-close" @click="fecharModalExportarLote">✕</button>

          <h3 class="modal-title">📄 Exportar PDF em Lote</h3>

          <label>Funcionários</label>

<div class="selecionar-todos">
  <input
    type="checkbox"
    :checked="todosFuncionariosSelecionados"
    @change="toggleSelecionarTodos"
  />
  <span>Selecionar todos</span>
</div>

<div class="lista-funcionarios">
  <label
    v-for="f in funcionariosLista"
    :key="f.id"
    class="item-funcionario"
  >
    <input
      type="checkbox"
      :value="f.id"
      v-model="exportarLote.funcionarios"
    />
    {{ f.nome }}
  </label>
</div>

          <label>Data Início</label>
          <input type="date" v-model="exportarLote.data_inicio" class="input" />

          <label>Data Fim</label>
          <input type="date" v-model="exportarLote.data_fim" class="input" />

          <div class="modal-acoes">
            <button class="btn-secundario" @click="fecharModalExportarLote">Cancelar</button>
            <button
              class="btn-primario"
              @click="exportarPDFLote"
              :disabled="exportandoPDF"
            >
              <span v-if="exportandoPDF" class="btn-loading">
                <span class="spinner-btn"></span>
                Gerando...
              </span>
              <span v-else>
                Gerar PDF
              </span>
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>


<script>
import { adminService } from '@/services/adminService';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import L from 'leaflet';

export default {
  name: 'ConsultaPontos',
  data() {
    return {
      funcionariosLista: [],
      registros: [],
      filtros: {
        funcionario_id: '',
        data_inicio: '',
        data_fim: ''
      },
      loading: false,
      
      selfieUrl: null,
      showSelfieModal: false,
      
      // Modal de ajuste
      showModal: false,
      ajusteData: null,
      horaAjuste: "18:00",

      exportarLoteModal: false,
      exportarLote: {
        funcionarios: [],
        data_inicio: '',
        data_fim: ''
      },
      
      exportandoPDF: false,

      // Mapa
      mostrarModalMapa: false,
      registroSelecionado: null,
      mapa: null
    };
  },
  computed: {
    registrosAgrupados() {
      const grupos = {};

      this.registros.forEach(r => {
        const dataObj = new Date(r.registro_timestamp);
        const ano = dataObj.getFullYear();
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0');
        const dia = String(dataObj.getDate()).padStart(2, '0');
        const data = `${ano}-${mes}-${dia}`;

        if (!grupos[data]) grupos[data] = [];
        grupos[data].push(r);
      });

      // Adiciona flag "semSaida" em cada grupo
      const resultado = {};
      for (const [data, registros] of Object.entries(grupos)) {
        const temSaida = registros.some(r =>
          r.registro_tipo?.toLowerCase().includes('saida')
        );
        resultado[data] = {
          registros,
          semSaida: !temSaida
        };
      }

      return resultado;
    },
    todosFuncionariosSelecionados() {
      return (
        this.exportarLote.funcionarios.length === this.funcionariosLista.length &&
        this.funcionariosLista.length > 0
      );
    }
  },
  async mounted() {
    await this.carregarFuncionarios();
  },
  methods: {
    async abrirModalSelfie(fileKey) {
      try {
        const response = await adminService.getSelfie(fileKey);
        this.selfieUrl = response.data.url;
        this.showSelfieModal = true;
      } catch (err) {
        console.error(err);
        alert("Erro ao carregar selfie");
      }
    },

    toggleSelecionarTodos(e) {
      if (e.target.checked) {
        this.exportarLote.funcionarios = this.funcionariosLista.map(f => f.id);
      } else {
        this.exportarLote.funcionarios = [];
      }
    },

    abrirModalExportarLote() {
      this.exportarLoteModal = true;
    },

    fecharModalExportarLote() {
      this.exportarLoteModal = false;
      this.exportarLote = {
        funcionarios: [],
        data_inicio: '',
        data_fim: ''
      };
    },

    fecharModalSelfie() {
      this.showSelfieModal = false;
      this.selfieUrl = null;
    },
    async carregarFuncionarios() {
      try {
        const response = await adminService.listFuncionarios();
        this.funcionariosLista = response.data;
      } catch (err) {
        console.error('Erro ao carregar funcionários:', err);
        alert('Erro ao carregar lista de funcionários.');
      }
    },

    async buscarRegistros() {
      if (!this.filtros.funcionario_id || !this.filtros.data_inicio || !this.filtros.data_fim) {
        alert('Preencha todos os filtros antes de buscar.');
        return;
      }

      this.loading = true;
      try {
        const response = await adminService.getPontosPorPeriodo(
          Number(this.filtros.funcionario_id),
          this.filtros.data_inicio,
          this.filtros.data_fim
        );
        // console.log('Registros brutos:', response.data);
        this.registros = response.data.sort(
          (a, b) => new Date(a.registro_timestamp) - new Date(b.registro_timestamp)
        );
        // console.log(this.registros);
      } catch (error) {
        console.error('Erro ao buscar registros:', error);
        alert(error.response?.data?.detail || 'Erro ao buscar registros.');
      } finally {
        this.loading = false;
      }
    },

    abrirModal(data) {
      this.ajusteData = data;
      this.horaAjuste = "00:00";
      this.showModal = true;
    },
    fecharModal() {
      this.showModal = false;
      this.ajusteData = null;
      this.horaAjuste = "18:00";
    },
    async confirmarAjuste() {
      if (!this.horaAjuste) {
        alert("Selecione a hora do ajuste");
        return;
      }

      try {
        const [hours, minutes] = this.horaAjuste.split(':').map(Number);
        const [year, month, day] = this.ajusteData.split('-').map(Number);
        // const dataCompleta = new Date(this.ajusteData);
        const dataCompleta = new Date(year, month - 1, day, hours, minutes, 0, 0);
      
        dataCompleta.setHours(hours, minutes, 0, 0);

        const timezoneOffset = dataCompleta.getTimezoneOffset(); // em minutos
        const dataCorrigida = new Date(dataCompleta.getTime() - timezoneOffset * 60000);

        const dataISO = dataCorrigida.toISOString().slice(0, 19) + '-03:00';

        // console.log('Data ISO final:', dataISO);

        // console.log(dataCompleta);


        await adminService.ajustar_saida(this.filtros.funcionario_id, dataISO);

        alert("Saída ajustada com sucesso!");
        this.fecharModal();
        await this.buscarRegistros();
      } catch (err) {
        console.error("Erro ao ajustar saída:", err);
        alert(err.response?.data?.detail || "Erro ao ajustar saída");
      }
    },

    formatDate(ts) {
      return new Date(ts).toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'medium'
      });
    },

    formatDateTitle(dataStr) {
      const [year, month, day] = dataStr.split('-');
      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    formatarDia(data) {
      const d = new Date(data);
      return d.toLocaleDateString('pt-BR', {
        weekday: 'long',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    },

    formatarDiaAjustado(dataIso) {
      if (!dataIso) return '-';
      const base = dataIso.split('T')[0] || dataIso;
      const [ano, mes, dia] = base.split('-');
      if (!ano || !mes || !dia) return dataIso;
      return `${dia}/${mes}/${ano}`;
    },

    statusClass(status) {
      if (!status) return '';
      const s = status.toLowerCase();
      if (s.includes('entrada') || s.includes('trabalhando')) return 'status-trabalhando';
      if (s.includes('pausa')) return 'status-pausa';
      if (s.includes('saida') || s.includes('inativo')) return 'status-inativo';
      return 'status-default';
    },

    abrirMapaRegistro(reg) {
      this.registroSelecionado = reg;
      this.mostrarModalMapa = true;
      this.$nextTick(() => {
        this.renderizarMapa();
      });
    },

    renderizarMapa() {
      if (!this.registroSelecionado || !this.registroSelecionado.latitude || !this.registroSelecionado.longitude) return;
      const center = [this.registroSelecionado.latitude, this.registroSelecionado.longitude];

      if (this.mapa) {
        this.mapa.remove();
        this.mapa = null;
      }

      this.mapa = L.map(this.$refs.mapaContainer, {
        zoomControl: true,
        scrollWheelZoom: true,
      }).setView(center, 16);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.mapa);

      L.marker(center).addTo(this.mapa).bindPopup(this.registroSelecionado.localizacao_atual || 'Registro');
    },

    fecharModalMapa() {
      this.mostrarModalMapa = false;
      this.registroSelecionado = null;
      if (this.mapa) {
        this.mapa.remove();
        this.mapa = null;
      }
    },

    async exportarPDFLote(){
      if (this.exportandoPDF) return;

      this.exportandoPDF = true;

      const { funcionarios, data_inicio, data_fim } = this.exportarLote;

      if (!funcionarios.length || !data_inicio || !data_fim) {
        alert('Selecione funcionários e período.');
        return;
      }

      try {
        for (const funcionarioId of funcionarios) {
          await this.gerarEspelhoPDF(
            funcionarioId,
            data_inicio,
            data_fim
          );
        }

      } catch (err) {
        console.error(err);
        alert('Erro ao gerar PDF em lote');
      } finally {
        this.exportandoPDF = false;
      }
    },

    segundosParaHora(segundos) {
      if (!segundos && segundos !== 0) return '-';

      const h = Math.floor(segundos / 3600);
      const m = Math.floor((segundos % 3600) / 60);
      const s = segundos % 60;

      return `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    },

    async exportarPDF() {
      if (!this.filtros.funcionario_id || !this.filtros.data_inicio || !this.filtros.data_fim) {
        alert('Preencha todos os filtros antes de exportar.');
        return;
      }

      await this.gerarEspelhoPDF(
        this.filtros.funcionario_id,
        this.filtros.data_inicio,
        this.filtros.data_fim
      );
    },
    
    async gerarEspelhoPDF(funcionarioId, dataInicio, dataFim) {
      if (!funcionarioId || !dataInicio || !dataFim) {
        alert('Preencha todos os filtros antes de exportar.');
        return;
      }

      try {
        const response = await adminService.getEspelhoPonto(
          funcionarioId,
          dataInicio,
          dataFim
        );
        
        const { totais, registros } = response.data;

        const doc = new jsPDF();

        const pageWidth = doc.internal.pageSize.getWidth();

        // 🔹 LOGO (se quiser usar imagem base64 depois)
        // doc.addImage(logoBase64, 'PNG', 14, 10, 25, 12);

        // 🔹 Nome da empresa
        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        doc.text('PLANNED MÓVEIS PLANEJADOS', 14, 15);

        doc.setFontSize(9);
        doc.setFont(undefined, 'normal');
        doc.text('Espelho de Ponto', 14, 21);

        // Linha divisória
        doc.setDrawColor(200);
        doc.line(14, 24, pageWidth - 14, 24);

        // 🔹 Dados do funcionário
        const funcionario = this.funcionariosLista.find(
          f => f.id === funcionarioId
        )?.nome || '';

        doc.setFontSize(9);
        doc.text(`Funcionário: ${funcionario}`, 14, 30);
        doc.text(`Período: ${dataInicio} até ${dataFim}`, 14, 35);

        // 🔹 TABELA
        const tableData = registros.map(dia => [
          this.formatarDiaAjustado(dia.data),
          dia.entrada !== null ? this.segundosParaHora(dia.entrada) : dia.status_dia,
          dia.saida !== null ? this.segundosParaHora(dia.saida) : dia.status_dia,
          dia.tempo_trabalhado !== null ? this.segundosParaHora(dia.tempo_trabalhado) : dia.status_dia,
          dia.tempo_pausa !== null ? this.segundosParaHora(dia.tempo_pausa) : dia.status_dia
        ]);

        autoTable(doc, {
          startY: 40,
          head: [['Data', 'Entrada', 'Saída', 'Trabalhado', 'Pausa']],
          body: tableData,
          theme: 'grid',
          styles: {
            fontSize: 8,
            cellPadding: 2,
            valign: 'middle'
          },
          headStyles: {
            fillColor: [30, 41, 59], // azul corporativo escuro
            textColor: 255,
            fontStyle: 'bold'
          },
          alternateRowStyles: {
            fillColor: [245, 247, 250] // cinza bem leve
          },
          didParseCell: function (data) {
            if (data.section === 'body') {
              const status = data.row.raw[1];

              if (status === 'FALTA') {
                data.cell.styles.textColor = [220, 38, 38]; // vermelho
                data.cell.styles.fontStyle = 'bold';
              }

              if (status === 'FOLGA') {
                data.cell.styles.textColor = [107, 114, 128]; // cinza
              }
            }
          }
        });

        // 🔹 RESUMO ESTILO ERP (ULTRA COMPACTO)

        const resumoY = doc.lastAutoTable.finalY + 6;

        doc.setDrawColor(0);
        doc.line(14, resumoY - 3, pageWidth - 14, resumoY - 3);

        doc.setFontSize(8);
        doc.setFont(undefined, 'bold');

        // Linha 1
        doc.text(
          `QTD DIAS TRABALHADOS: ${String(totais.dias_trabalhados).padStart(2, '0')}      ` +
          `TOT. HRS TRAB MÊS: ${totais.tempo_trabalhado}      ` +
          `QTD FALTAS: ${String(totais.faltas).padStart(2, '0')}      ` +
          `TOT. TEMPO PAUSA: ${totais.tempo_pausa}`,
          14,
          resumoY
        );

        // Linha inferior
        doc.line(14, resumoY + 9, pageWidth - 14, resumoY + 9);

        // 🔹 Rodapé com paginação
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setFontSize(8);
          doc.setTextColor(150);
          doc.text(
            `Página ${i} de ${pageCount}`,
            pageWidth - 30,
            doc.internal.pageSize.getHeight() - 10
          );
        }

        doc.save(
          `espelho_ponto_${funcionario}_${dataInicio}_${dataFim}.pdf`
        );

      } catch (err) {
        console.error('Erro ao exportar PDF:', err);
        alert('Erro ao gerar relatório PDF.');
      }
    },

    segundosParaHHMM(segundos) {
      const h = Math.floor(segundos / 3600);
      const m = Math.floor((segundos % 3600) / 60);
      return `${h}h ${m}m`;
    },

    diasUteisNoPeriodo(inicio, fim) {
      const dias = [];
      const start = this.parseIsoDateOnly(inicio);
      const end = this.parseIsoDateOnly(fim);
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const diaSemana = d.getDay();
        if (diaSemana !== 0 && diaSemana !== 6) { // apenas seg-sex
          const ano = d.getFullYear();
          const mes = String(d.getMonth() + 1).padStart(2, '0');
          const dia = String(d.getDate()).padStart(2, '0');
          dias.push(`${ano}-${mes}-${dia}`);
        }
      }
      return dias;
    },

    tempoParaSegundos(tempoStr) {
      if (!tempoStr || typeof tempoStr !== 'string') return 0;
      const [h, m, sRaw] = tempoStr.split(':');
      const sParts = (sRaw || '0').split('.');
      const s = sParts[0];
      return Number(h || 0) * 3600 + Number(m || 0) * 60 + Number(s || 0);
    },

    parseIsoDateOnly(dataStr) {
      if (!dataStr) return new Date();
      const [y, m, d] = dataStr.split('-').map(Number);
      return new Date(y, (m || 1) - 1, d || 1);
    }
  }
};
</script>

<style scoped>
.consulta-pontos {
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background: #f8fafc;
  min-height: 100vh;
  font-family: 'Inter', sans-serif;
}

/* Cabeçalho */
.header { text-align: center; margin-bottom: 1rem; }
.titulo { font-size: 1.6rem; font-weight: 700; color: #1e293b; }

/* Filtros */
.filtro-section {
  background: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  margin-bottom: 1.5rem;
}
.filtro-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.campo {
  flex: 1;
  min-width: 180px;
  display: flex;
  flex-direction: column;
}
.campo label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #334155;
  margin-bottom: 0.3rem;
}
.input {
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 0.6rem 0.9rem;
  font-size: 0.95rem;
}
.acoes {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
}
.btn-primario, .btn-secundario {
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  padding: 0.6rem 1rem;
  transition: 0.2s;
}
.btn-primario {
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
}
.btn-primario:hover { transform: translateY(-2px); box-shadow: 0 3px 8px rgba(37,99,235,0.3); }
.btn-secundario { background: #e2e8f0; color: #1e293b; }
.btn-secundario:hover { background: #cbd5e1; }
.btn-mapa {
  background: #e2e8f0;
  border: none;
  padding: 0.4rem 0.55rem;
  border-radius: 8px;
  cursor: pointer;
  color: #0f172a;
}
.btn-mapa:hover { background: #cbd5e1; }

/* Estado */
.estado { text-align: center; padding: 2rem; color: #475569; }
.estado.vazio i { font-size: 2rem; color: #cbd5e1; }
.spinner {
  width: 40px; height: 40px;
  border: 4px solid #e2e8f0; border-top: 4px solid #3b82f6;
  border-radius: 50%; margin: 0 auto 1rem;
  animation: spin 1s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* Lista de dias */
.lista-dias { display: flex; flex-direction: column; gap: 1.5rem; }

/* Cada card do dia agora permite scroll horizontal */
.card-dia {
  background: white;
  border-radius: 12px;
  box-shadow: 0 1px 5px rgba(0,0,0,0.06);
  padding: 1rem 1.2rem;
  overflow-x: auto;                /* ✅ Scroll lateral */
  -webkit-overflow-scrolling: touch; /* Scroll suave no iOS */
}

.card-dia::-webkit-scrollbar {
  height: 6px;
}
.card-dia::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.cabecalho-dia {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.8rem;
  flex-wrap: wrap;
}
.cabecalho-dia h3 {
  font-weight: 700;
  color: #1e293b;
  text-transform: capitalize;
}
.alerta {
  background: #fee2e2;
  color: #991b1b;
  padding: 0.3rem 0.6rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.btn-ajustar {
  background: #f97316;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.2rem 0.6rem;
  cursor: pointer;
  font-weight: 600;
}
.btn-ajustar:hover { background: #ea580c; }

/* Tabela */
.tabela-pontos {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  min-width: 600px; /* ✅ garante largura mínima pro scroll */
}
.tabela-pontos th, .tabela-pontos td {
  white-space: nowrap; /* ✅ evita quebra no mobile */
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
}
.tabela-pontos th {
  background: #f3f4f6;
  color: #1e293b;
  font-weight: 600;
}
.status-trabalhando { background: #dcfce7; color: #166534; }
.status-pausa { background: #fef9c3; color: #854d0e; }
.status-inativo { background: #fee2e2; color: #991b1b; }
.status-default { background: #e2e8f0; color: #334155; }

/* Botão selfie */
.btn-selfie {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px; height: 35px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s;
}
.btn-selfie:hover { transform: scale(1.1); }

/* Modal */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 1rem;
}
.modal {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  position: relative;
  animation: scaleIn 0.25s ease;
}
.modal-close {
  position: absolute; top: 12px; right: 14px;
  background: none; border: none; font-size: 1.2rem;
  cursor: pointer; color: #64748b;
}
.modal-close:hover { color: #1e293b; }
.modal-title {
  text-align: center; font-weight: 700;
  color: #1e293b; margin-bottom: 1rem;
}
.modal-subtitle { color: #475569; margin-bottom: .6rem; text-align: center; }
.mapa-container {
  height: 260px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  margin-bottom: .6rem;
}
.coords {
  color: #475569;
  font-size: 0.9rem;
  margin-bottom: 0.6rem;
}
.modal-acoes {
  display: flex; justify-content: flex-end; gap: 0.5rem; margin-top: 1rem;
}
.selfie-img {
  max-width: 100%; max-height: 70vh;
  border-radius: 12px;
  margin-bottom: 1rem;
}

/* Animações */
.fade-enter-active, .fade-leave-active { transition: all 0.25s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(10px); }
@keyframes scaleIn { from { transform: scale(0.9); opacity: 0; } to { transform: scale(1); opacity: 1; } }

.w-full { width: 100%; }

/* Modal mobile first */
.modal-mobile {
  max-width: 100%;
  width: 100%;
  height: auto;
  max-height: 90vh;
  border-radius: 16px 16px 0 0;
  padding: 1.2rem;
  overflow-y: auto;
}

/* Quando for desktop */
@media (min-width: 768px) {
  .modal-mobile {
    max-width: 420px;
    border-radius: 16px;
  }
}

.modal-mobile label {
  font-weight: 600;
  margin-top: 0.8rem;
  display: block;
}

.modal-mobile .input {
  margin-top: 0.3rem;
}

.modal-mobile .modal-acoes {
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 0.8rem;
}

.selecionar-todos {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  margin: 0.5rem 0;
}

.lista-funcionarios {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  max-height: 200px;
  overflow-y: auto;
  padding: 0.5rem;
}

.item-funcionario {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 0.2rem;
  font-size: 0.95rem;
}

.btn-primario:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.spinner-btn {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255,255,255,0.5);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}


</style>
